import type { ClientOfferReviewUnit } from '../../client-offer-review';

interface RestoreAllPeriodsParams {
  acceptedUnits: ClientOfferReviewUnit[];
  selectedPeriods: Record<string, string[]>;
  defaultPeriodIdsByUnitId: Map<string, string[]>;
  onPeriodSelect: (itemId: string, periodId: string, nowSelected: boolean) => void;
}

/**
 * Toggles each period back to its default state — safer than re-triggering
 * handleDecisionChange, whose resolveAcceptedPeriods keeps an existing
 * non-empty custom selection unchanged rather than resetting it.
 */
export function createRestoreAllPeriodsToDefault({
  acceptedUnits,
  selectedPeriods,
  defaultPeriodIdsByUnitId,
  onPeriodSelect,
}: RestoreAllPeriodsParams): () => void {
  return () => {
    for (const unit of acceptedUnits) {
      const current = new Set(selectedPeriods[unit.id] ?? []);
      const defaults = new Set(defaultPeriodIdsByUnitId.get(unit.id) ?? []);
      for (const id of current) if (!defaults.has(id)) onPeriodSelect(unit.id, id, false);
      for (const id of defaults) if (!current.has(id)) onPeriodSelect(unit.id, id, true);
    }
  };
}
